'use strict';
var escapeRegExp, initRegExp, regexp, replacements;

escapeRegExp = require('../../../../../core/frontend/common/underscore_mixins').escapeRegExp;

regexp = replacements = null;

initRegExp = function() {
  var char, charMap, dest, i, key, len, len1, src, val;
  charMap = window.Groupon.LS.data.charMapping || {};
  replacements = {};
  regexp = '';
  val = _.values(charMap);
  key = _.keys(charMap);
  regexp = new RegExp('[' + escapeRegExp(val.join('')) + ']', 'g');
  len = val.length;
  while (len--) {
    src = val.pop();
    dest = key.pop();
    for (i = 0, len1 = src.length; i < len1; i++) {
      char = src[i];
      replacements[char] = dest;
    }
  }
  return regexp;
};

module.exports = function(s) {
  if (typeof s !== 'string') {
    return '';
  }
  s = s.trim().replace(regexp || initRegExp(), function(c) {
    return replacements[c];
  });
  return s.toLowerCase();
};

